import "./About.css";
import bannerImg from "../assets/products/320-3.png";
import storyImg1 from "../assets/products/320-2.png";
import storyImg2 from "../assets/products/640-3.png";
import storyImg3 from "../assets/products/arabic.png";

import NavBar from '../components/Navbar';

const About = () => {
  return (
    <>
    <NavBar textColor="#000"/>
    <div className="about-page">
      {/* Hero Section */}
      <div className="about-hero" style={{ backgroundImage: `url(${bannerImg})` }}>
        <div className="about-hero-overlay">
          <h1>OUR STORY</h1>
        </div>
      </div>

     {/* Story Section */}
<section className="about-text">
  <h2 className="about-title">
    <span className="accent-pill">Locally made in the Netherlands</span>
    <br/>
    <span className="title-light">  Pure sesame. True to taste.</span>
  </h2>

  <p className="lead">
    At <strong>Holland Tahini</strong>, we proudly craft every jar <strong>locally in the Netherlands</strong>, 
    ensuring the kind of freshness and consistency you can trust. Our journey begins with 
    sourcing the <span className="accent">finest sesame seeds</span> from <strong>Ethiopia</strong> and <strong>Sudan</strong>—regions 
    renowned for exceptional harvests. Each seed is carefully selected for quality and flavor 
    before arriving at our facility in the Netherlands.
    <br /><br />
    Here, our tahini chefs prepare every batch under <strong>strict EU food safety standards</strong>, using 
    nothing but <strong>100% sesame seeds</strong>—no additives, no compromises. Our goal is simple: to bring the 
    <span className="accent"> authentic, nutty character of sesame</span> from farm to table—fresh, pure, and true to its origins.
  </p>
</section>


      {/* Two-column sections */}
      <section className="about-row">
        <div className="about-image">
          <img src={storyImg1} alt="Tahini making" />
        </div>
        <div className="about-content">
          <h3>From Seed to Jar</h3>
          <p>
            Holland Tahini is our delicious answer to healthy eating through the pure power of sesame seeds.Our sesame seeds are carefully sourced and crafted into rich tahini
            that’s packed with flavor, nutrition, and tradition. 
          </p>
        </div>
      </section>

      <section className="about-row reverse">
        <div className="about-image">
          <img src={storyImg2} alt="Family tradition" />
        </div>
        <div className="about-content">
          <h3>A Family Tradition</h3>
          <p>
            Holland Tahini’s 100% Sesame Butter is our delicious answer to healthy, nutritious, and creative eating with the pure power of tahini.We believe food brings people together. That’s why we’ve made it our
            mission to share the goodness of sesame with families everywhere.
          </p>
        </div>
      </section>

      <section className="about-row">
        <div className="about-image">
          <img src={storyImg3} alt="Healthy lifestyle" />
        </div>
        <div className="about-content">
          <h3>Fueling Healthy Living</h3>
          <p>
            Tahini is more than just a spread — it’s a source of energy, protein,
            and inspiration for your meals. From smoothies to sauces, tahini is
            at the heart of healthy living.
          </p>
        </div>
      </section>
    </div>
    </>
  );
};

export default About;